import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

import assest1 from "../assets/blogs/1.png";
import assest2 from "../assets/blogs/2.png";
import assest3 from "../assets/blogs/3.png";
import assest4 from "../assets/blogs/4.png";
import assest5 from "../assets/blogs/5.png";
import assest6 from "../assets/blogs/6.png";
import assest7 from "../assets/blogs/7.png";
import assest8 from "../assets/blogs/8.png";
import assest9 from "../assets/blogs/9.png";
import assest10 from "../assets/blogs/10.png";
import assest11 from "../assets/blogs/11.png";
import assest12 from "../assets/blogs/12.png";

export default function Blog() {
    return (
        <div className="font-sans text-gray-800 bg-[#FAFCFF]">
            <Navbar />
            
            <section className="py-16 md:py-24">
                {/* Increased max-width from 900px to 1280px to make it much wider */}
                <div className="max-w-[1280px] mx-auto px-6 md:px-12">
                    
                    {/* PAGE HEADER - Removed text-center so it aligns left */}
                    <div className="mb-16">
                        <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6 tracking-tight">
                            Our Blogs
                        </h1>
                        {/* Removed mx-auto to prevent centering */}
                        <p className="text-xl text-[#1A73E8] font-medium max-w-3xl mb-6">
                            Beauty is more than appearance, it is confidence, care, expression, and intention.
                        </p>
                        <p className="text-lg text-gray-600 leading-relaxed font-light max-w-4xl">
                            At WamGlammz Insights, we share expert knowledge across skin care, makeup, hair, photography, and professional beauty services. These articles are written to help you make informed choices, understand the value of skilled professionals, and approach beauty with clarity and purpose.
                        </p>
                    </div>

                    <div className="space-y-20 text-gray-700 leading-[1.8] text-[16px] md:text-[17px]">
                        
                        {/* --- SKIN CARE ROUTINES --- */}
                        <section>
                            <h2 className="text-[#1A73E8] text-sm font-bold tracking-widest uppercase border-b-2 border-blue-100 pb-2 mb-6">
                                Skin Care Routines
                            </h2>
                            <h3 className="text-2xl font-bold text-gray-900 mb-6">
                                Skin Care Routines That Build Confidence, Not Confusion
                            </h3>
                            
                            {/* Image Grid 1-3 - Increased height slightly to adapt to the wider layout */}
                            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
                                <img src={assest1} alt="Skin care 1" className="w-full h-[250px] md:h-[300px] object-cover rounded-xl shadow-sm" />
                                <img src={assest2} alt="Skin care 2" className="w-full h-[250px] md:h-[300px] object-cover rounded-xl shadow-sm" />
                                <img src={assest3} alt="Skin care 3" className="w-full h-[250px] md:h-[300px] object-cover rounded-xl shadow-sm" />
                            </div>
                            
                            <p className="text-gray-600 max-w-5xl">
                                Healthy skin is the foundation of confidence. A thoughtful skin care routine supports long-term skin health, balance, and clarity without unnecessary complexity.
                            </p>
                        </section>

                        {/* --- MAKEUP & HAIR (PART 1) --- */}
                        <section>
                            <h2 className="text-[#1A73E8] text-sm font-bold tracking-widest uppercase border-b-2 border-blue-100 pb-2 mb-6">
                                Makeup & Hair Define Personality
                            </h2>
                            
                            {/* Image Grid 4-6 */}
                            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
                                <img src={assest4} alt="Makeup 1" className="w-full h-[250px] md:h-[300px] object-cover rounded-xl shadow-sm" />
                                <img src={assest5} alt="Makeup 2" className="w-full h-[250px] md:h-[300px] object-cover rounded-xl shadow-sm" />
                                <img src={assest6} alt="Makeup 3" className="w-full h-[250px] md:h-[300px] object-cover rounded-xl shadow-sm" />
                            </div>
                            
                            <p className="text-gray-600 max-w-5xl">
                                Written in the same editorial tone as your Skin Care article, clean, credible, non-salesy, and aligned with WamGlammz Insights.
                            </p>
                        </section>

                        {/* --- CHOOSING THE RIGHT PHOTOGRAPHER --- */}
                        <section>
                            <h2 className="text-[#1A73E8] text-sm font-bold tracking-widest uppercase border-b-2 border-blue-100 pb-2 mb-6">
                                Choosing the Right Photographer
                            </h2>
                            
                            {/* Image Grid 7-9 */}
                            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
                                <img src={assest7} alt="Photography 1" className="w-full h-[250px] md:h-[300px] object-cover rounded-xl shadow-sm" />
                                <img src={assest8} alt="Photography 2" className="w-full h-[250px] md:h-[300px] object-cover rounded-xl shadow-sm" />
                                <img src={assest9} alt="Photography 3" className="w-full h-[250px] md:h-[300px] object-cover rounded-xl shadow-sm" />
                            </div>

                            <div className="bg-white p-6 rounded-xl border border-gray-100 shadow-sm max-w-2xl">
                                <h4 className="font-bold text-gray-900 mb-3">WHY THESE WORK:</h4>
                                <ul className="list-decimal pl-5 space-y-2 text-gray-600">
                                    <li>Highlights process, not just results</li>
                                    <li>Builds credibility and professionalism</li>
                                    <li>Avoids staged influencer photos</li>
                                </ul>
                            </div>
                        </section>

                        {/* --- DEEP DIVE ARTICLE: MAKEUP & HAIR --- */}
                        <section className="bg-white p-8 md:p-12 rounded-2xl shadow-sm border border-gray-100">
                            <h2 className="text-[#1A73E8] text-sm font-bold tracking-widest uppercase mb-4 block">
                                Makeup & Hair Define Personality
                            </h2>
                            <h3 className="text-3xl md:text-4xl font-bold text-gray-900 leading-tight mb-6">
                                How Makeup and Hair Define Personality and Tell Your Story
                            </h3>
                            <p className="text-xl text-gray-500 font-light mb-10 max-w-4xl">
                                Discover how makeup and hair reflect personality, confidence, culture, and intention. From natural and office looks to fashion and wedding beauty, every style tells a story.
                            </p>

                            <div className="space-y-8 text-gray-600 max-w-5xl">
                                <div>
                                    <h4 className="text-xl font-bold text-gray-900 mb-3">How Makeup and Hair Tell Your Story</h4>
                                    <p>
                                        Makeup and hair are often seen as tools of appearance, but in reality, they are powerful forms of self-expression. Long before words are spoken, how someone presents themselves communicates confidence, intention, culture, and personality. Every makeup look and hairstyle tells a story not about trends, but about identity.
                                    </p>
                                </div>

                                <div>
                                    <h4 className="text-xl font-bold text-gray-900 mb-3">Beauty as Expression, Not Disguise</h4>
                                    <p className="mb-3">
                                        True beauty does not hide who you are; it reveals it. Makeup and hair allow individuals to express different sides of their personality depending on the moment, environment, and purpose.
                                    </p>
                                    <p>
                                        Some days call for simplicity and softness. Others invite boldness, creativity, or celebration. These choices are not random; they reflect how a person feels, who they are, and how they want to show up in the world.
                                    </p>
                                </div>

                                <div>
                                    <h4 className="text-xl font-bold text-gray-900 mb-3">Natural Makeup: Confidence in Authenticity</h4>
                                    <p className="mb-3">
                                        Natural makeup focuses on enhancing features while maintaining authenticity. It reflects comfort, self-awareness, and quiet confidence. Rather than covering the face, this style highlights healthy skin, subtle definition, and balance.
                                    </p>
                                    <p className="mb-3">
                                        Natural makeup is often chosen for everyday wear, wellness-focused lifestyles, casual settings, and moments where presence matters more than performance. It communicates ease, approachability, and self-trust.
                                    </p>
                                    <p className="font-medium text-[#1E40AF] bg-blue-50 px-4 py-3 rounded-lg border-l-2 border-[#1d1ae8]">
                                        This approach to beauty reinforces the idea that confidence begins with being comfortable in your own skin.
                                    </p>
                                </div>

                                <div>
                                    <h4 className="text-xl font-bold text-gray-900 mb-3">Office Makeup: Professional Presence and Clarity</h4>
                                    <p className="mb-3">
                                        Office makeup is designed with intention. It communicates professionalism, reliability, and preparedness without distraction. Clean lines, balanced tones, and polished hair help create a composed appearance that supports confidence in professional environments.
                                    </p>
                                    <p className="mb-3">
                                        In workplaces, interviews, and leadership roles, makeup and hair choices contribute to how others perceive credibility and attention to detail. When done thoughtfully, professional beauty enhances presence rather than overpowering it.
                                    </p>
                                    <p>
                                        Office makeup is not about glamour—it is about clarity, confidence, and respect for the setting.
                                    </p>
                                </div>

                                <div>
                                    <h4 className="text-xl font-bold text-gray-900 mb-3">Fashion Makeup: Creativity and Individuality</h4>
                                    <p className="mb-3">
                                        Fashion makeup allows for freedom and experimentation. It reflects creativity, boldness, and artistic identity. Colors, textures, and styles become tools for storytelling rather than rules to follow.
                                    </p>
                                    <p className="mb-3">
                                        This form of beauty is often seen in editorial work, runways, creative industries, and personal branding moments. It allows individuals to explore different facets of themselves and communicate confidence through originality.
                                    </p>
                                    <p>
                                        Fashion makeup is not about fitting in, it is about standing out with intention.
                                    </p>
                                </div>

                                <div>
                                    <h4 className="text-xl font-bold text-gray-900 mb-3">Wedding Makeup: Timeless, Cultural, and Emotional</h4>
                                    <p className="mb-3">
                                        Wedding makeup carries deep emotional and cultural meaning. It blends tradition, personal identity, and celebration into a look designed to be remembered for a lifetime.
                                    </p>
                                    <p className="mb-3">
                                        Whether subtle or glamorous, bridal makeup reflects heritage, values, and the significance of the moment. It must last through emotions, movement, photography, and long hours while remaining timeless in memories and images.
                                    </p>
                                    <p>
                                        Wedding beauty is not about trends. It is about honoring the individual and the story they are stepping into.
                                    </p>
                                </div>

                                <div>
                                    <h4 className="text-xl font-bold text-gray-900 mb-3">Hair as Identity and Presence</h4>
                                    <p className="mb-3">
                                        Hair frames the face and plays a powerful role in personal identity. Hairstyles can signal confidence, elegance, creativity, or transformation. They often reflect cultural background, personal history, and emotional transitions.
                                    </p>
                                    <p className="mb-3">
                                        A well-chosen hairstyle enhances posture, presence, and how someone carries themselves. From sleek professional styles to soft natural textures or celebratory designs, hair choices contribute significantly to how beauty is experienced and perceived.
                                    </p>
                                    <p>
                                        Hair is not just styling—it is identity in motion.
                                    </p>
                                </div>

                                <div>
                                    <h4 className="text-xl font-bold text-gray-900 mb-3">Beauty Choices and Confidence</h4>
                                    <p className="mb-3">
                                        When makeup and hair are chosen intentionally, they empower rather than overwhelm. Working with skilled professionals ensures that beauty aligns with personality, comfort, and occasion.
                                    </p>
                                    <p className="mb-3">
                                        The most impactful beauty looks do not follow trends blindly. They respect individuality, context, and purpose.
                                    </p>
                                    <p>
                                        Confidence grows when beauty feels aligned, not forced.
                                    </p>
                                </div>

                                {/* Article Conclusion */}
                                <div className="bg-[#1E40AF] text-white p-8 rounded-xl mt-10">
                                    <h4 className="text-2xl font-bold mb-4">Beauty That Tells the Right Story</h4>
                                    <p className="mb-4 text-blue-100">
                                        Makeup and hair are not about perfection. They are about expression, confidence, and storytelling. Every look communicates something meaningful, whether subtle or bold.
                                    </p>
                                    <p className="mb-6 text-blue-100">
                                        When beauty choices reflect who you are and the moment you are in, they become powerful tools of self-expression—telling your story before you ever speak.
                                    </p>
                                </div>
                            </div>
                        </section>

                        {/* --- ESTHETICIANS --- */}
                        <section>
                            <h2 className="text-[#1A73E8] text-sm font-bold tracking-widest uppercase border-b-2 border-blue-100 pb-2 mb-6">
                                Estheticians
                            </h2>
                            
                            {/* Image Grid 10-12 */}
                            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
                                <img src={assest10} alt="Esthetician 1" className="w-full h-[250px] md:h-[300px] object-cover rounded-xl shadow-sm" />
                                <img src={assest11} alt="Esthetician 2" className="w-full h-[250px] md:h-[300px] object-cover rounded-xl shadow-sm" />
                                <img src={assest12} alt="Esthetician 3" className="w-full h-[250px] md:h-[300px] object-cover rounded-xl shadow-sm" />
                            </div>

                            <div className="bg-white p-6 rounded-xl border border-gray-100 shadow-sm max-w-2xl">
                                <h4 className="font-bold text-gray-900 mb-3">WHY THESE WORK:</h4>
                                <ul className="list-decimal pl-5 space-y-2 text-gray-600">
                                    <li>Emphasizes science + care</li>
                                    <li>Clinic-grade, not spa fluff</li>
                                    <li>Builds confidence in professional expertise</li>
                                </ul>
                            </div>
                        </section>

                    </div>
                </div>
            </section>
            
            <Footer />
        </div>
    );
}